import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AddTickets from './AddTickets';
import PriceLevel from './PriceLevel';
import FormattedCurrency from '@checkout-s/FormattedCurrency';
import DetailsToggle from '@checkout-s/DetailsToggle';
import Translation from '@checkout-s/Translation';
import { Callout } from './Callout';

class KioskPriceLevel extends PriceLevel {

    feeDisplay = () => {
        if (this.props.customFeeDisplay !== undefined) {
            return this.props.customFeeDisplay;
        }
        const serviceFee = this.serviceFee();
        if (serviceFee > 0) {
            return (
                <Fragment>
                    <div className="ticket__price"><FormattedCurrency>{ this.basePrice() }</FormattedCurrency> + <FormattedCurrency>{ serviceFee }</FormattedCurrency> Fee</div>
                </Fragment>
            )
        }
        return (
            <Fragment>
                <div className="ticket__price"><FormattedCurrency>{ this.basePrice() }</FormattedCurrency></div>
            </Fragment>
        )
    }

    render() {
        return(
            <div className="ticket-container">
                <div className="ticket">
                    <Callout callout={this.props.level.callout} />
                    <div className="ticket__inner">
                        <div className="ticket__information">
                            {this.props.level.wasHidden === true &&
                                <div className="ticket-availability"><Translation>{'checkout__access_code_applied'}</Translation></div>
                            }
                            <div className="ticket__name">{ this.props.level.name }</div>
                            <div className="ticket__pricing-group">
                                {this.feeDisplay()}
                            </div>
                            {!!this.props.level.description && (
                              <DetailsToggle
                                onClick={this.toggleDescription}
                                aria-expanded={this.state.showDescription}
                                aria-controls={`description_price-level_${this.props.level.price_level_id}`}
                              />
                            )}
                        </div>

                        <div className="ticket__action">
                            <AddTickets
                                onIncrement={this.props.onIncrement}
                                onDecrement={this.props.onDecrement}
                                quantity={this.props.quantity}
                                quantities={this.props.quantities}
                                onQuantityInput={this.props.onQuantityInput}
                                initialQuantities={this.props.initialQuantities}
                                disabled={!!this.props.disabled}
                            />
                        </div>
                    </div>
                </div>
                {this.props.level.description && this.state.showDescription === true && (
                    <div
                      id={`description_price-level_${this.props.level.price_level_id}`}
                      className="ticket-description__more"
                    >
                        <div className="ticket__description">
                            <div className="ticket-description__content ticket-description__content-desc">
                                {this.props.level.description}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

KioskPriceLevel.propTypes = {
    level: PropTypes.object.isRequired,
    slug: PropTypes.string,
    quantity: PropTypes.number,
    quantities: PropTypes.arrayOf(PropTypes.number).isRequired,
    initialQuantities: PropTypes.arrayOf(PropTypes.number),
    onQuantityInput: PropTypes.func.isRequired,
    onIncrement: PropTypes.func.isRequired,
    onDecrement: PropTypes.func.isRequired,
}

export default KioskPriceLevel
